export const RESET_USER = 'RESET_user';
export const RESET_USER_SUCCESSFUL = 'RESET_user_successfull';
export const RESET_PASSWORD_API_FAILED = 'RESET_PASSWORD_API_FAILED';
